//mui components
import MDBox from "components/MDBox";
import { Container, Grid } from "@mui/material";
import MDTypography from "components/MDTypography";

//images
// import logoMain from "assets/images/logo-main.svg";
import logoMain from "assets/images/home-page-images/FooterLogo.png";

import worldIcon from "assets/images/small-logos/world-icon.svg";
import messageIcon from "assets/images/pricing/Message.png";
import callIcon from "assets/images/pricing/Call.png";
import Vector1 from "assets/images/home-page-images/Vector1.png";
import Vector2 from "assets/images/home-page-images/Vector.png";
import world from "assets/images/icons/world.png";
import { NavLink } from "react-router-dom";

function Footer() {
  return (
    <MDBox sx={{ backgroundColor: "#000000E5", pt: { xs: 2, sm: 3, md: 4 }, pb: { xs: 2, sm: 3, md: 3 } }}>
      <MDBox
        sx={{
          width: "95%",
          margin: "auto",
          "@media (min-width:1580px)": {
            maxWidth: "1600px!important",
            pt: 0.5,
          },
        }}
      >
        <Grid
          container
          sx={{ display: "flex", justifyContent: "space-between" }}
        >
          <Grid item xxl={5} lg={3} md={6}>
            <MDBox
              sx={{
                display: "flex",
                alignItems: "start",
                flexDirection: "column",
                justifyContent: "start",
                "@media(max-width:767px)": { py: 2 },
                "@media(min-width:1200px)": { mr: 3 },
                "@media(min-width:1400px)": { mr: 4 },
              }}
            >
              <MDBox
                sx={{
                  mb: { xs: 0, sm: 4, md: 4 },
                  width: { xs: "130px", sm: "190px", md: "170px" },
                  height: {
                    xs: "30px",
                    sm: "60px",
                    md: "auto",
                  },
                }}
              >
                <NavLink to="/">
                  <img
                    src={logoMain}
                    alt="logo"
                    style={{ maxWidth: "100%", height: "auto" }}
                  />
                </NavLink>
              </MDBox>

              <MDBox>
                <MDTypography
                  sx={{
                    display: {
                      xs: "none",
                      sm: "block",
                      md: "block",
                    },
                    width: "95%",
                    color: "#fff",
                    fontSize: "16px",
                    fontFamily: "Poppins",
                    lineHeight: 1.2,
                  }}
                >
                  We empower businesses with intelligent tools that drive
                  growth, connection, and lasting impact.
                </MDTypography>
              </MDBox>
              <MDBox sx={{ mt: 3 }}>
                <NavLink to="/privacy-policy">
                  <MDTypography
                    sx={{
                      display: {
                        xs: "none",
                        sm: "block",
                        md: "block",
                      },
                      width: "100%",
                      color: "#fff",
                      fontSize: "16px",
                      fontFamily: "Poppins",
                      lineHeight: 1.2,
                    }}
                  >
                    Privacy Policy
                  </MDTypography>
                </NavLink>
              </MDBox>
              <MDBox>
                <NavLink to="/terms-conditions">
                  <MDTypography
                    sx={{
                      display: {
                        xs: "none",
                        sm: "block",
                        md: "block",
                      },
                      width: "100%",
                      color: "#fff",
                      fontSize: "16px",
                      fontFamily: "Poppins",
                      lineHeight: 1.2,
                    }}
                  >
                    Terms and Conditions
                  </MDTypography>
                </NavLink>
              </MDBox>
            </MDBox>
          </Grid>
          <Grid
            item
            xxl={7}
            lg={9}
            md={6}
            sx={{
              display: "flex",
              gap: {
                xs: 0,
                sm: 0,
              },
              width: { xs: "100%", sm: "100%", md: "auto" },
              justifyContent: "space-evenly",
              "@media(min-width:1200px)": { flexDirection: "row" },
              flexDirection: "column",
            }}
          >
            <MDBox
              sx={{
                width: { xs: "100%", sm: "100%", md: "auto" },
                color: "#fff",
                mb: { xs: 1, sm: 0, md: 0 },
              }}
            >
              <MDBox
                sx={{
                  width: { xs: "100%", sm: "100%", md: "auto" },
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" },
                  justifyContent: "space-between",
                  px: { xs: 2 },
                  gap: {
                    xs: 0,
                    sm: 3,
                    md: 4,
                  },
                }}
              >
                <MDBox sx={{ width: "100%" }}>
                  <MDTypography
                    variant="h6"
                    sx={{
                      fontFamily: "Inter",
                      fontSize: {
                        xs: "20px",
                        sm: "16px",
                        md: "22px",
                      },
                      fontWeight: 800,
                      mb: { xs: 1, sm: 2 },
                      color: "#fff",
                      textAlign: { xs: "center", md: "left" },
                    }}
                  >
                    Pages
                  </MDTypography>

                  <MDBox
                    sx={{
                      display: "flex",
                      flexDirection: { xs: "row", md: "column" },
                      flexWrap: "wrap",
                      justifyContent: { xs: "center", md: "flex-start" },
                      alignItems: { xs: "center", md: "flex-start" },
                      gap: { xs: 2.6, md: 0 },
                    }}
                  >
                    {[
                      { label: "About", path: "/about" },
                      { label: "Pricing", path: "/pricing" },
                      { label: "Insights", path: "/insight" },
                      { label: "Contact Us", path: "/contact" },
                    ].map((item) => (
                      <NavLink key={item.label} to={item.path}>
                        <MDBox
                          component="span"
                          sx={{
                            textDecoration: "none",
                            color: "#fff",
                            fontWeight: 400,
                            fontSize: {
                              xs: "17px",
                              sm: "16px",
                              md: "16px",
                            },
                            fontFamily: "Inter",
                            lineHeight: 1.2,
                          }}
                        >
                          {item.label}
                        </MDBox>
                        {/* {item.label} */}
                      </NavLink>
                    ))}
                  </MDBox>
                </MDBox>
              </MDBox>
            </MDBox>

            <MDBox
              sx={{
                color: "#fff",
                display: {
                  xs: "none",
                  sm: "block",
                  md: "block",
                },
              }}
            >
              <MDBox
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" },
                  justifyContent: "space-between",
                  px: { xs: 2 },
                  gap: 4,
                }}
              >
                <MDBox>
                  <MDTypography
                    variant="h6"
                    sx={{
                      fontWeight: "700",
                      mb: { xs: 1, sm: 2 },
                      fontFamily: "Inter",
                      fontSize: "21px",
                      color: "#fff",
                    }}
                  >
                    Services
                  </MDTypography>
                  <MDTypography
                    variant="body1"
                    sx={{
                      mb: 1,
                      color: "#fff",
                      fontSize: "16px",
                      fontFamily: "Inter",
                    }}
                  >
                    Review Management
                  </MDTypography>
                  <MDTypography
                    variant="body1"
                    sx={{
                      mb: 1,
                      color: "#fff",
                      fontSize: "16px",
                      fontFamily: "Inter",
                    }}
                  >
                    Local Intelligence
                  </MDTypography>
                  <MDTypography
                    variant="body1"
                    sx={{
                      mb: 1,
                      color: "#fff",
                      fontSize: "16px",
                      fontFamily: "Inter",
                    }}
                  >
                    Growth intelligence
                  </MDTypography>
                  <MDTypography
                    variant="body1"
                    sx={{
                      color: "#fff",
                      fontSize: "16px",
                      fontFamily: "Inter",
                    }}
                  >
                    Tavlo Moments{" "}
                  </MDTypography>
                </MDBox>
              </MDBox>
            </MDBox>

            <MDBox sx={{ color: "#fff" }}>
              <MDBox
                sx={{
                  display: "flex",
                  flexDirection: { xs: "row", md: "column" },
                  justifyContent: "space-between",
                  alignItems: "center",
                  px: { xs: 2 },
                  gap: 0,
                }}
              >
                <MDBox
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    px: { xs: 2 },
                  }}
                >
                  <MDTypography
                    variant="h6"
                    sx={{
                      fontWeight: "700",
                      mb: { xs: 1, sm: 2 },
                      fontFamily: "Inter",
                      fontSize: "20px",
                      color: "#fff",
                      fontFamily: "Inter",
                      textAlign: { xs: "center", sm: "start", md: "start" },
                    }}
                  >
                    Contact
                  </MDTypography>
                  {/* <MDBox
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: {
                        xs: "center",
                        sm: "start",
                        md: "start",
                      },

                      fontFamily: "Inter",
                      mb: 2,
                    }}
                  >
                    <MDBox
                      sx={{
                        mr: 1,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontFamily: "Inter",
                      }}
                    >
                      <img
                        src={world}
                        alt="message icon"
                        style={{ maxWidth: "15px" }}
                      />
                    </MDBox>

                    <MDBox>
                      <MDTypography
                        sx={{
                          color: "#ffffff",
                          fontSize: { xs: "15px", sm: "15px:", md: "16px" },
                          lineHeight: "19px",
                          "@media(max-width:340px)": { letterSpacing: "0rem" },
                          fontFamily: "Inter",
                        }}
                      >
                        www.gratitudesystems.com
                      </MDTypography>
                    </MDBox>
                  </MDBox> */}
                  <MDBox
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: {
                        xs: "center",
                        sm: "start",
                        md: "start",
                      },
                      mb: 2,
                    }}
                  >
                    <MDBox
                      sx={{
                        mr: 1,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <img
                        src={messageIcon}
                        alt="message icon"
                        style={{ maxWidth: "15px" }}
                      />
                    </MDBox>

                    <MDBox>
                      <MDTypography
                        sx={{
                          color: "#ffffff",
                          fontSize: { xs: "15px", sm: "15px:", md: "16px" },
                          lineHeight: "19px",
                          fontFamily: "Poppins",
                          fontFamily: "Inter",
                          "@media(max-width:340px)": { letterSpacing: "0rem" },
                        }}
                      >
                        support@tavloai.com
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                  <MDBox
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: {
                        xs: "start",
                        sm: "start",
                        md: "start",
                      },
                      mb: 2,
                    }}
                  >
                    <MDBox
                      sx={{
                        mr: 0.8,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <img
                        src={callIcon}
                        alt="message icon"
                        style={{ maxWidth: "15px" }}
                      />
                    </MDBox>

                    <MDBox>
                      <MDTypography
                        sx={{
                          color: "#ffffff",
                          fontSize: { xs: "15px", sm: "15px:", md: "16px" },
                          lineHeight: "19px",
                          fontWeight: "500",
                          "@media(max-width:340px)": { letterSpacing: "0rem" },
                          fontFamily: "Inter",
                        }}
                      >
                        (202)240-7754
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                </MDBox>
                {/* follow Us  */}
                <MDBox>
                  <MDBox
                    sx={{
                      color: "#ffffff",
                      fontSize: {
                        xs: "18px",
                        sm: "16px",
                        md: "18px",
                      },
                      lineHeight: "19px",
                      fontWeight: "600",
                      mb: 1,
                      // ml: 2,
                      textAlign: { xs: "center", sm: "start", md: "start" },
                    }}
                  >
                    Follow Us On
                  </MDBox>
                  <MDBox
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mb: 2,
                      ml: 2,
                    }}
                  >
                    <NavLink
                      target="_blank"
                      to="https://www.facebook.com/TavloAI"
                    >
                      <MDBox
                        sx={{
                          mr: 1.6,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          src={Vector2}
                          alt="message icon"
                          style={{ maxWidth: "25px" }}
                        />
                      </MDBox>
                    </NavLink>
                    <NavLink
                      target="_blank"
                      to="https://www.instagram.com/tavloai/"
                    >
                      <MDBox
                        sx={{
                          mr: 1.6,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          src={Vector1}
                          alt="message icon"
                          style={{ maxWidth: "25px" }}
                        />
                      </MDBox>
                    </NavLink>
                  </MDBox>
                </MDBox>
              </MDBox>
            </MDBox>
          </Grid>
        </Grid>
        <MDBox
          sx={{
            width:"80%",
            margin:"auto",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            mb:{
                    xs: 1,
                    sm:0,
                    md: 0,
                  } ,
          }}
        >
          <MDBox sx={{ width: "40%",  }}>
            <NavLink to="/privacy-policy">
              <MDTypography
                sx={{
                  display: {
                    xs: "block",
                    sm: "none",
                    md: "none",
                  },
                  width: "100%",
                  color: "#fff",
                 fontSize:{
                    xs: "15px",
                    sm:"16px",
                    md: "16px",
                  } ,
                  fontFamily: "Poppins",
                  lineHeight: 1.2,
                }}
              >
                Privacy Policy
              </MDTypography>
            </NavLink>
          </MDBox>
          <MDBox sx={{ width: "60%" }}>
            <NavLink to="/terms-conditions">
              <MDTypography
                sx={{
                  display: {
                    xs: "block",
                    sm: "none",
                    md: "none",
                  },
                  width: "100%",
                  color: "#fff",
                  fontSize:{
                    xs: "15px",
                    sm:"16px",
                    md: "16px",
                  } ,
                  fontFamily: "Poppins",
                  lineHeight: 1.2,
                }}
              >
                Terms and Conditions
              </MDTypography>
            </NavLink>
          </MDBox>
        </MDBox>

        <MDBox
          sx={{
            textAlign: "center",
             fontSize:{
                    xs: "13px",
                    sm:"16px",
                    md: "16px",
                  } ,
                  mt:1,
            fontFamily: "Poppins",
            color: "#fff",
          }}
        >
          Copyright © 2025 TavloAi, All rights reserved.
        </MDBox>
      </MDBox>
    </MDBox>
  );
}

export default Footer;
